<template>
    <el-tabs type="border-card" :lazy="true">
        <el-tab-pane label="全部订单">
            <order :type="1"/>
        </el-tab-pane>
        <el-tab-pane label="待接单">
            <order :type="2"/>
        </el-tab-pane>
        <el-tab-pane label="派送中">
            <order :type="3"/>
        </el-tab-pane>
        <el-tab-pane label="已送达">
            <order :type="4"/>
        </el-tab-pane>
        <el-tab-pane label="已完成">
            <order :type="5"/>
        </el-tab-pane>
        <el-tab-pane label="退款/售后">
            <order :type="6"/>
        </el-tab-pane>
        <el-tab-pane label="已退款">
            <order :type="7"/>
        </el-tab-pane>
        <el-tab-pane label="退款驳回">
            <order :type="8"/>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    import order from "../../views/order/order";
    export default {
        components:{order},
        data(){
            return{

            }
        },
        mounted() {
        },
        methods:{

        }
    }
</script>